import { render, staticRenderFns } from "./IMView.vue?vue&type=template&id=a592c072&scoped=true&"
import script from "./IMView.vue?vue&type=script&lang=js&"
export * from "./IMView.vue?vue&type=script&lang=js&"
import style0 from "./IMView.vue?vue&type=style&index=0&id=a592c072&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a592c072",
  null
  
)

export default component.exports